module.exports = __webpack_public_path__ + "static/media/MMNT_logo1.ab6cf0a0.jpg";